import React from 'react';

import { appMethod as app } from '@utils/app';
import { convertStyleData, transformPx2Rem } from '@utils/tools';
import { ScrollView } from 'src/jisu-component/scroll-view/ScrollView';
import { RequestStatus } from 'src/common/request-status/RequestStatus';
import { LoadingBtn } from 'src/common/loading-btn/LoadingBtn';

import './GroupBuyListCustomComponent.less';

/**
 * type: 'group-buy-list'
 * 组件：拼团列表组件
 */
export default class GroupBuyListCustomComponent extends React.Component {

  constructor(props) {
    super(props);
    const compindex = props.index;
    const pageInstance = app.getAppCurrentPage();
    this.init(compindex, pageInstance);
  }

  init = (compindex, pageInstance) => {
    let that = this;
    let customFeature = pageInstance.data.eles[compindex].customFeature;
    let param = {
      page: 1,
      status: 0,
    };
    // TODO: 拼团状态组件初始化，应该要挪到对应组件里面设置
    pageInstance.data.eles.forEach((ele, eleIndex) => {
      if (ele.type === 'group-buy-status' && customFeature.id === ele.customFeature.status_refresh_object) {
        let statusCompindex = eleIndex;
        let groupStatusData = pageInstance.data.eles[statusCompindex].customFeature;
        let checkOptionsOne = groupStatusData.checkOptionsOne;
        for (let selectIndex in checkOptionsOne) {
          if (checkOptionsOne[selectIndex].checked) {
            param = {
              page: 1,
              status: selectIndex,
            }
            let newdata = {};
            newdata['eles[' + statusCompindex + '].customFeature.selectNum'] = selectIndex;
            newdata['eles[' + compindex + '].selectNum'] = selectIndex;
            pageInstance.setData(newdata);
            break;
          }
        }
      }
    })
    let newClassifyCompid = app.getInvolvedFromRefreshObject(customFeature.id, 'new-classify', 'refresh_object', pageInstance);
    if (!newClassifyCompid) {
      that.getGroupBuyList(compindex, param);
    }
  }

  getGroupBuyList = (compindex, param) => {
    let pageInstance = app.getAppCurrentPage();
    let newdata = {};
    let compData = pageInstance.data.eles[compindex];
    let customFeature = compData.customFeature;
    let loadingNum = customFeature.loadingNum || 10;
    newdata['eles[' + compindex + '].loading'] = true;
    newdata['eles[' + compindex + '].loadingFail'] = false;
    newdata['eles[' + compindex + '].goods_data'] = [];
    newdata['eles[' + compindex + '].is_more'] = 1;
    newdata['eles[' + compindex + '].curpage'] = 0;
    //清除定时器
    if (pageInstance.downcountObject && pageInstance.downcountObject[compindex]) {
      let downcountArr = pageInstance.downcountObject[compindex];
      if (downcountArr && downcountArr.length) {
        for (let i = 0; i < downcountArr.length; i++) {
          downcountArr[i] && downcountArr[i].clear();
        }
      }
    }
    pageInstance.setData(newdata);

    param.page_size = loadingNum;
    if (customFeature.source && customFeature.source != 'none') {
      param.idx_arr = {
        idx: 'category',
        idx_value: customFeature.source
      }
    }
    if (customFeature.isShowFranchiseeGoods && !pageInstance.franchiseeId) { // 是否多店拼团(排除子店功能页)
      param['parent_app_id'] = app.getAppId();
    }
    app.sendRequest({
      hideLoading: true, // 页面第一个请求才展示loading
      url: '/index.php?r=appGroupBuy/goodsList',
      data: param,
      method: 'post',
      chain: true,
      subshop: pageInstance.franchiseeId || '',
      success: function (res) {
        if (res.data) {
          let rdata = res.data,
            appId = app.getAppId(),
            newdata = {},
            downcountArr = [];

          for (let i = 0; i < rdata.length; i++) {
            let f = rdata[i],
              dc;
            f.description = '';
            f.downCount = {
              hours: '00',
              minutes: '00',
              seconds: '00'
            };
            f.original_price = f.virtual_price == '0.00' ? f.original_price : f.virtual_price;
            f.server_time = res.current_time || (Date.parse(new Date()) / 1000);
            f.seckill_end_time = f.end_date;
            f.seckill_start_time = f.start_date;
            if (f.status == 0 || f.status == 1 || f.status == 2) {
              dc = app.beforeGroupDownCount(f, pageInstance, 'eles[' + compindex + ']goods_data[' + i + ']');
            } else if (f.status == 3) {
              if (f.end_date != '-1') {
                dc = app.duringGroupDownCount(f, pageInstance, 'eles[' + compindex + ']goods_data[' + i + ']');
              }
            }
            dc && downcountArr.push(dc);
            if (customFeature.isShowFranchiseeGoods && f.app_id !== appId) {
              f.isSubShopGoods = true;
            }else {
              f.isSubShopGoods = false;
            }
          }
          newdata['eles[' + compindex + '].goods_data'] = res.data;
          newdata['eles[' + compindex + '].is_more'] = res.is_more;
          newdata['eles[' + compindex + '].curpage'] = res.current_page;
          newdata['eles[' + compindex + '].loading'] = false;
          newdata['eles[' + compindex + '].loadingFail'] = false;
          pageInstance.downcountObject[compindex] = downcountArr;
          pageInstance.setData(newdata);
        }
      },
      fail: function (res) {
        let newdata = {};
        newdata['eles[' + compindex + '].loadingFail'] = true;
        newdata['eles[' + compindex + '].loading'] = false;
        pageInstance.setData(newdata);
      }
    });
  }

  remainMe = (e) => {
    let pageInstance = app.getAppCurrentPage();
    let data = e.currentTarget.dataset;
    let compindex = data.compindex;
    let index = data.index;

    app.sendRequest({
      url: '/index.php?r=appShop/careActivity',
      data: {
        data_id: data.goodsid,
        activity_id: data.activityid,
        activity_type: 0
      },
      success: res => {
        app.showToast({
          title: '提醒成功！',
          duration: 2000
        });
        var newdata = {};
        newdata['eles[' + compindex + '].goods_data[' + index + '].status'] = 2
        pageInstance.setData(newdata);
      }
    });
    this.groupSaveUserFormId(e.detail.formId);
  }

  catchMoreGroupList = (event) => {
    let pageInstance = app.getAppCurrentPage();
    let compindex = typeof event == 'object' ? event.currentTarget.dataset.compindex : event;
    let compData = pageInstance.data.eles[compindex];
    let customFeature = compData.customFeature;
    let curpage = compData.curpage + 1;
    let param = {};
    let newData = {};

    if (compData.loading || !compData.is_more) {
      return;
    }
    newData['eles[' + compindex + '].loading'] = true;
    newData['eles[' + compindex + '].loadingFail'] = false;
    pageInstance.setData(newData);

    param.page_size = customFeature.loadingNum || 10;
    param.page = curpage;
    param.status = 0;
    param.is_count = 0;
    param.status = compData.selectNum;
    if (customFeature.source && customFeature.source != 'none'){
      param.idx_arr = {
        idx: 'category',
        idx_value: customFeature.source
      }
    }
    if (customFeature.isShowFranchiseeGoods && !pageInstance.franchiseeId) { // 是否多店拼团(排除子店功能页)
      param['parent_app_id'] = app.getAppId();
    }

    app.sendRequest({
      hideLoading: true,
      url: '/index.php?r=appGroupBuy/goodsList',
      data: param,
      method: 'post',
      chain: true,
      subshop: pageInstance.franchiseeId || '',
      success: function(res) {
        if (res.data) {
          let rdata = res.data,
            appId = app.getAppId(),
            newdata = {},
            length = compData.goods_data.length,
            downcountArr = pageInstance.downcountObject[compindex] || [];

          for (let i = 0; i < rdata.length; i++) {
            let f = rdata[i],
              dc;
            f.description = '';
            f.downCount = {
              hours: '00',
              minutes: '00',
              seconds: '00'
            };
            f.server_time = res.current_time || (Date.parse(new Date()) / 1000);
            f.seckill_end_time = f.end_date;
            f.seckill_start_time = f.start_date;
            if (f.status == 0 || f.status == 1 || f.status == 2) {
              dc = app.beforeGroupDownCount(f, pageInstance, 'eles[' +compindex + ']goods_data[' + (i + length) + ']');
            } else if (f.status == 3) {
              if (f.end_date != '-1') {
                dc = app.duringGroupDownCount(f, pageInstance, 'eles[' +compindex + ']goods_data[' + (i + length) + ']');
              }
            }
            dc && downcountArr.push(dc);
            if (customFeature.isShowFranchiseeGoods && f.app_id !== appId) {
              f.isSubShopGoods = true;
            }else {
              f.isSubShopGoods = false;
            }
          }
          var dataArr = res.data;
          newdata['eles[' + compindex + '].goods_data'] = compData.goods_data.concat(dataArr);
          newdata['eles[' + compindex + '].is_more'] = res.is_more;
          newdata['eles[' + compindex + '].curpage'] = res.current_page;
          newdata['eles[' + compindex + '].loading'] = false;
          newdata['eles[' + compindex + '].loadingFail'] = false;
          pageInstance.downcountObject[compindex] = downcountArr;
          pageInstance.setData(newdata);
        }

      },
      fail: function(res) {
        let newdata = {};
        newdata['eles[' + compindex + '].loadingFail'] = true;
        newdata['eles[' + compindex + '].loading'] = false;
        pageInstance.setData(newdata);
      }
    });

  }

  gotoGroupDetail = (e) => {
    let data = e.currentTarget.dataset;
    let appId = data.appId;
    let franchisee = app.getPageFranchiseeId();
    let chainParam = franchisee ? '&franchisee=' + franchisee : '';
    if (appId && appId !== app.getAppId() && chainParam === '') {
      chainParam = '&franchisee=' + appId;
    }
    let pageUrl = data.status == 4 ? '/pages/goodsDetail/goodsDetail?detail=' + data.goodsid + chainParam : '/group/pages/gpgoodsDetail/gpgoodsDetail?goods_id=' + data.goodsid + '&activity_id=' + data.activityid + chainParam;
    app.turnToPage(pageUrl);
  }

  groupSaveUserFormId = (formId) => {
    let pageInstance = app.getAppCurrentPage();
    app.sendRequest({
      hideLoading: true,
      url: '/index.php?r=api/AppMsgTpl/saveUserFormId',
      data: {
        form_id: [formId]
      },
      chain: true,
      subshop: pageInstance.franchiseeId || '',
      method: 'post'
    });
  }

  _refreshGroupBuyList = (targetCompIndex, requestData, pageInstance) => {
    let _this = this;
    let compdata = pageInstance.data.eles[targetCompIndex];
    let customFeature = compdata.customFeature;
    let newData = {};

    newData['eles[' + targetCompIndex + '].loading'] = true;
    newData['eles[' + targetCompIndex + '].loadingFail'] = false;
    newData['eles[' + targetCompIndex + '].is_more'] = 1;
    newData['eles[' + targetCompIndex + '].goods_data'] = [];
    pageInstance.setData(newData);

    requestData.page_size = customFeature.loadingNum || 10;
    requestData.status = compdata.selectNum || 0;
    if (customFeature.source && customFeature.source != 'none') {
      requestData.idx_arr = {
        idx: 'category',
        idx_value: customFeature.source
      }
    }

    //清除定时器
    if (pageInstance.downcountObject && pageInstance.downcountObject[targetCompIndex]) {
      let downcountArr = pageInstance.downcountObject[targetCompIndex];
      if (downcountArr && downcountArr.length) {
        for (let i = 0; i < downcountArr.length; i++) {
          downcountArr[i] && downcountArr[i].clear();
        }
      }
    }
    // 是否多店拼团(排除子店功能页)
    if (customFeature.isShowFranchiseeGoods && !pageInstance.franchiseeId) {
      requestData['parent_app_id'] =app.getAppId();
    }

    app.sendRequest({
      url: '/index.php?r=appGroupBuy/goodsList',
      method: 'post',
      hideLoading: true,
      data: requestData,
      chain: true,
      success: function (res) {
        let rdata = res.data,
          newdata = {},
          downcountArr = [];

        for (let i = 0; i < rdata.length; i++) {
          let f = rdata[i],
            dc;
          f.description = '';
          f.downCount = {
            hours: '00',
            minutes: '00',
            seconds: '00',
            days: '00'
          };
          f.original_price = f.virtual_price == '0.00' ? f.original_price : f.virtual_price;
          f.server_time = res.current_time || (Date.parse(new Date()) / 1000);
          f.seckill_end_time = f.end_date;
          f.seckill_start_time = f.start_date;
          if (f.status == 0 || f.status == 1 || f.status == 2) {
            dc = app.beforeGroupDownCount(f, pageInstance, 'eles[' + targetCompIndex + '].goods_data[' + i + ']');
          } else if (f.status == 3) {
            if (f.end_date != '-1') {
              dc = app.duringGroupDownCount(f, pageInstance, 'eles[' + targetCompIndex + '].goods_data[' + i + ']');
            }
          }
          dc && downcountArr.push(dc);
        }

        newdata['eles[' + targetCompIndex + '].goods_data'] = rdata;
        newdata['eles[' + targetCompIndex + '].is_more'] = res.is_more;
        newdata['eles[' + targetCompIndex + '].curpage'] = res.current_page;
        newdata['eles[' + targetCompIndex + '].loading'] = false;
        newdata['eles[' + targetCompIndex + '].loadingFail'] = false;
        pageInstance.downcountObject[targetCompIndex] = downcountArr;
        pageInstance.setData(newdata);
      },
      fail: function (res) {
        let newData = {};
        newData['eles[' + targetCompIndex + '].loadingFail'] = true;
        newData['eles[' + targetCompIndex + '].loading'] = false;
        pageInstance.setData(newData);
      }
    })
  }
  
  render() {
    const data = this.props.data;
    const { customFeature, goods_data } = data;
    const styleObj = convertStyleData(data.style);
    // 是否为竖版
    const hor = customFeature.mode == 2 && data.curpage > 0;
    let {
      mode, lineHeight, margin,
      lineBackgroundColor, imgHeight, imgWidth,
      isShowGroupBuyStatus, isShowCountdown, isShowVirtualPrice,
      isShowSales
    } = customFeature;

    lineHeight = transformPx2Rem(lineHeight, 320);
    margin = transformPx2Rem(margin, 320);
    imgHeight = transformPx2Rem(imgHeight, 320);
    imgWidth = transformPx2Rem(imgWidth, 320);

    /**
     * @desc 状态
     */
    const joinStatus = (item, index) => (
      <div className="to-join">
        {item.status == 0 && <button className="ready">即将开团</button>}
        {item.status == 1 && <button className="remain"
                                     data-goodsid={item.goods_id}
                                     data-activityid={item.activity_id}
                                     data-index={index}
                                     data-compindex={this.props.index}
                                     onClick={this.remainMe}>提醒我</button>}
        {item.status == 2 && <button className="reminded">已提醒</button>}
        {item.status == 3 && <button className="go">{item.activity_type == 4 ? '参与抽奖' : '去拼团'}</button>}
        {item.status == 4 && <button className="over">已结束</button>}
      </div>
    )

    const salesWrap = (item, index) => {
      let wrap = null;
      if ((mode == 1 || mode == 2) && isShowSales) {
        wrap =
          <div className="hava-sales">
            <div className="price">
              <span className="min-price">¥<span style={{ fontSize: '.36rem' }}>{item.group_buy_price}</span></span>
              {isShowVirtualPrice && <span className="origin-price">¥{item.original_price}</span>}
            </div>
            <div className="status">
              <div className="sales">已团{item.goods_count}件</div>
              {joinStatus(item, index)}
            </div>
          </div>
      } else if ((mode == 1 || mode == 2) && !isShowSales) {
        wrap =
          <div className="no-sales">
            <div className="price">
              <div className="min-price">
                ¥<span style={{ fontSize: '.36rem' }}>{item.group_buy_price}</span>
              </div>
              {isShowVirtualPrice && <div className="origin-price">¥{item.original_price}</div>}
            </div>
            {joinStatus(item, index)}
          </div>
      } else if (mode == 3) {
        wrap =
          <div className="sales-status">
            <div className="price">
              <span className="min-price">¥<span style={{ fontSize: '.36rem' }}>{item.group_buy_price}</span></span>
              {isShowVirtualPrice && <span className="origin-price">¥{item.original_price}</span>}
              {isShowSales && <div className="sales">已团{item.goods_count}件</div>}
            </div>
            <div className="status">
              {joinStatus(item, index)}
            </div>
          </div>
      }
      return wrap;
    }

    const groupListOne = () => {
      return <div className="js-list-container group-list list">
        {goods_data && goods_data.map((item, index) =>
          <div className="background-ele goods-item"
            key={index}
            style={{
              height: lineHeight,
              marginBottom: margin,
              background: lineBackgroundColor
            }}
            data-goodsid={item.goods_id}
            data-activityid={item.activity_id}
            data-status={item.status}
            data-app-id={item.app_id}
            onClick={this.gotoGroupDetail}>
            <div className="image-wrap"
              style={{
                width: imgWidth,
                height: imgHeight
              }}>
              <img src={item.cover} />
            </div>
            <div className="content-wrap"
              style={{ width: `calc(100% - ${imgWidth} - .2rem)` }}>
              <div className="title">
                {isShowGroupBuyStatus &&
                  <div className="type" style={{ background: lineBackgroundColor }}>
                    <div>
                      <i className="icon-moon icon-number-people"></i>
                    </div>
                    <span>
                      {item.activity_type == 0
                        ? (item.num_of_people.length > 1 ? '多人团' : item.num_of_people[0] + '人团')
                        : (item.activity_type == 1 ? '新人团' : (item.activity_type == 2 ? '阶梯团' : (item.activity_type == 3 ? '帮帮团' : '抽奖团')))
                      }
                    </span>
                  </div>
                }
                {item.isSubShopGoods ? '【' + item.app_sub_shop_name + '】' : ''}{item.title}
              </div>
              {(item.status != 4 && isShowCountdown && !(item.status == 3 && item.end_date == '-1'))
                ? <div className='same-line'>
                  <div className="first-line">
                    <div className="price-detail">
                      <span className="min-price">¥<span style={{ fontSize: '.37rem' }}>{item.group_buy_price}</span></span>
                      {isShowVirtualPrice && <span className="origin-price">¥{item.original_price}</span>}
                    </div>
                    {joinStatus(item, index)}
                  </div>
                  <div className="second-line">
                    <div className="sales-num">
                      {isShowSales && <React.Fragment>已团{item.goods_count}件</React.Fragment>}
                    </div>
                    {!(item.status == 3 && item.end_date == '-1') &&
                      <div className="count-big-down">
                        {item.status != 3 ? '距开始' : '距结束'}
                        {item.downCount.days != '00' && item.downCount.days != '0' ? item.downCount.days + '天' : ""}
                        {item.downCount.hours} : {item.downCount.minutes} : {item.downCount.seconds}
                      </div>
                    }
                  </div>
                </div>
                : <div className="differ-line">
                  <div className="first-line">
                    <div className="price-detail">
                      <span className="min-price">¥<span style={{ fontSize: '.36rem' }}>{item.group_buy_price}</span></span>
                      {isShowVirtualPrice && <span className="origin-price">¥{item.original_price}</span>}
                    </div>
                    <div className="sales-num">
                      {isShowSales && <React.Fragment>已团{item.goods_count}件</React.Fragment>}
                    </div>
                  </div>
                  <div className="second-line">
                    {joinStatus(item, index)}
                  </div>
                </div>
              }
            </div>
          </div>
        )}
      </div>
    }

    /**
     * @desc 团列表
     */
    const groupList = () => {
      const type = {
        1: 'opposite',
        3: 'bigPicture'
      }[mode] || '';
      return <div className={`js-list-container group-list ${type}`}>
        {goods_data && goods_data.map((item, index) =>
          <div className="background-ele goods-item"
            key={index}
            style={{
              height: lineHeight,
              marginBottom: margin,
              background: lineBackgroundColor
            }}
            data-goodsid={item.goods_id}
            data-activityid={item.activity_id}
            data-status={item.status}
            data-app-id={item.app_id}
            onClick={this.gotoGroupDetail}>
            <div className="image-wrap" style={{ width: imgWidth, height: imgHeight }}>
              <img src={item.cover} />
              {item.status != 4 && isShowCountdown &&
                <React.Fragment>
                  {!(item.status == 3 && item.end_date == '-1') && item.status != 4 &&
                    <div className={`count-down ${(item.status == 0 || item.status == 1) ? 'ready' : 'going'}`}>
                      <div className="group-buy-status">
                        {item.status != 3 && <React.Fragment>距开始</React.Fragment>}
                        {item.status == 3 && item.end_date != '-1' && <React.Fragment>距结束</React.Fragment>}
                      </div>
                      <div>
                        {item.downCount.days != '00' && item.downCount.days != '0' &&
                            <React.Fragment>
                              <div>{item.downCount.days}</div>
                              <span> 天 </span>
                            </React.Fragment>
                          }
                        <div>{item.downCount.hours}</div>
                        <span> : </span>
                        <div style={{ width: '.48rem' }}>{item.downCount.minutes}</div>
                        <span> : </span>
                        <div style={{ width: '.48rem' }}>{item.downCount.seconds}</div>
                      </div>
                    </div>
                  }
                </React.Fragment>
              }
            </div>
            <div className="content-wrap">
              <div className="title">
                {isShowGroupBuyStatus &&
                  <div className="type" style={{ background: lineBackgroundColor }}>
                    <div>
                      <i className="icon-moon icon-number-people"></i>
                    </div>
                    <span>
                      {item.activity_type == 0 ? (item.num_of_people.length > 1 ? '多人团' : item.num_of_people[0] + '人团')
                        : (item.activity_type == 1 ? '新人团' : (item.activity_type == 2 ? '阶梯团' : (item.activity_type == 3 ? '帮帮团' : '抽奖团')))
                      }
                    </span>
                  </div>
                }
                {item.isSubShopGoods ? '【' + item.app_sub_shop_name + '】' : ''}{item.title}
              </div>
              {salesWrap(item)}
            </div>
          </div>
        )}
      </div>
    }

    return (
      <div className="custom-component group-buy-list">
        <ScrollView
          className={`element group scroll-ele group-list-mode-${mode} ${(data.customFeature.mode == 2 && data.curpage > 0) ? 'hor-request-status' : ''}`}
          style={styleObj}
          data-compindex={this.props.index}
          data-type="group-list"
          scroll-y={ (data.customFeature.mode == 2 || data.customFeature.vesselAutoheight != 0) ? false : true }
          scroll-x={ data.customFeature.mode == 2 ? true : false }
          lower-threshold="100"
          bindscrolltolower={this.catchMoreGroupList} 
          // bindanimationend="animationEnd"
          >
          {mode == 0 && groupListOne()}
          {mode != 0 && groupList()}
          {/* 加载loading */}
          {
            data.loading &&
            <RequestStatus is="requestLoading" hor={hor}/>
          }
          {/* 加载没有数据 */}
          {
            data.is_more == 0 && data.goods_data.length == 0 && 
            <RequestStatus is="requestNone" data={{ data: "暂无商品" }} hor={hor}/>
          }
          {/* 加载失败 */}
          {
            data.loadingFail &&
            <RequestStatus is="requestFail" data={{ refreshEvent: this.catchMoreGroupList, compindex: this.props.index }} hor={hor}/>
          }
          {/* 加载完所有数据 */}
          {
            data.is_more == 0 && data.goods_data.length > 0 && data.customFeature.isShowFinishText && 
            <RequestStatus is="requestAll" hor={hor}/>}
          {/* 点击加载按钮 */}
          {
            data.customFeature.vesselAutoheight == 1 && data.customFeature.loadingMethod == 1 && data.customFeature.mode != 2 && !!data.is_more && data.is_more != 0 && !data.loading && !data.loadingFail &&
            <LoadingBtn customFeature={data.customFeature} data-compindex={this.props.index} onClick={this.catchMoreGroupList} />
          }
        </ScrollView>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/custom-component/group-buy-list-custom-component/GroupBuyListCustomComponent.jsx